import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  if (!date) return '';

  const isoDateOnly = date.split('T')[0]; // Get '2025-07-04'
  const fixedDate = new Date(isoDateOnly + 'T00:00:00'); // Avoid timezone shift

  return format(fixedDate, fm);
}
export function fDate1(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function isSameUTCDate(dateStr) {
  if (!dateStr) return false;

  const winDateUTC = new Date(dateStr);
  const todayUTC = new Date();

  // Get both in UTC yyyy-mm-dd format
  const winDateString = winDateUTC.toISOString().split('T')[0];
  const todayDateString = todayUTC.toISOString().split('T')[0];

  return winDateString === todayDateString;
}


